import { render, staticRenderFns } from "./NewFormWizard.vue?vue&type=template&id=2da4ef9f&scoped=true"
import script from "./NewFormWizard.vue?vue&type=script&lang=js"
export * from "./NewFormWizard.vue?vue&type=script&lang=js"
import style0 from "./NewFormWizard.vue?vue&type=style&index=0&id=2da4ef9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4ef9f",
  null
  
)

export default component.exports